import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function Content({ email, departments, onDepartmentSelect }) {
  return (
    <>
      <div className="remote-access-dialog__text">
        Welcome to Reaxys Choice Screen
        <br />
        To log in please select one of the departments below.
      </div>
      {departments && (
        <ul className="remote-access-dialog__departments-list">
          {departments.map((department) => (
            <li key={department.departmentId} className="remote-access-dialog__departments-list__item">
              <ButtonWithIcon
                type="link"
                sprite="ChevronRight"
                onClick={() => {
                  onDepartmentSelect(department, email);
                }}
                className="remote-access-dialog__departments-list__item__button e2e-remote-access-department-choice">
                {`${department.accountName}, ${department.departmentName}`}
              </ButtonWithIcon>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}

Content.propTypes = {
  email: PropTypes.string.isRequired,
  departments: PropTypes.array,
  onDepartmentSelect: PropTypes.func.isRequired,
};

export default Content;
